import { render, staticRenderFns } from "./RewardsStatus.vue?vue&type=template&id=1ca15199&scoped=true"
import script from "./RewardsStatus.vue?vue&type=script&lang=js"
export * from "./RewardsStatus.vue?vue&type=script&lang=js"
import style0 from "./RewardsStatus.vue?vue&type=style&index=0&id=1ca15199&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca15199",
  null
  
)

export default component.exports